<template>
  <div class="document-table-wrapper">
    <table class="pdf-table mt20">
      <tr>
        <td class="td25">
          <div class="pdf-logo-center">
            <div>
              <img src="../../../assets/img/pdf/gems.jpg" width="100%" />
            </div>
          </div>
        </td>
        <td class="td50">
          <div
            class="text-center text-bold"
            style="width:100%; border-bottom: 1px solid grey; font-size:22px"
          >
            GOLDEN ENERGY MINES (GEMS)
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            FORMULIR INFORMASI VENDOR DAN KELENGKAPAN LEGALITAS
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            BERBENTUK PERORANGAN
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 11px; font-style: italic"
          >
            INDIVIDUAL VENDOR INFORMATION AND LEGALITY REQUIREMENT
          </div>
        </td>
        <td class="td25">
          <div class="pdf-small-text text-center">F-SPM-01.01</div>
          <div class="pdf-small-text text-center">
            {{ formatFullDate(Date.now()) }}
          </div>
          <div class="pdf-small-text text-center">Page 1 of 2</div>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="pdf-text text-right text-bold">
          DI ISI DENGAN HURUF BESAR
        </td>
      </tr>
    </table>

    <table class="pdf-table">
      <tr>
        <td colspan="2" class="pdf-text td10 text-bold">NAMA VENDOR</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.nama }}
        </td>
      </tr>
      <tr>
        <td colspan="2" class="pdf-text text-bold">KEGIATAN USAHA UTAMA</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{
            `${$route.query.kbli1 ? `${$route.query.kbli1}` : ''}
                ${$route.query.kbli2 ? `, ${$route.query.kbli2}` : ''}
                ${$route.query.kbli3 ? `, ${$route.query.kbli3}` : ''}`
          }}
        </td>
      </tr>
      <tr>
        <td colspan="2" class="pdf-text text-bold">ALAMAT SESUAI KTP</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.alamat }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">Kel. & Kec.</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ `${$route.query.kec}` }}
        </td>
      </tr>
      <tr>
        <td class="right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">
          Kota & Provinsi
        </td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.kota }}
        </td>
      </tr>
      <tr>
        <td class="td10 right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">Kode Pos</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.kodepos }}
        </td>
      </tr>
      <tr>
        <td colspan="2" class="pdf-text td10 text-bold">
          TELEPON/HANDPHONE
        </td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.no_tlp }}
        </td>
      </tr>
      <tr>
        <td colspan="2" class="pdf-text td10 text-bold">EMAIL</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.email }}
        </td>
      </tr>
      <tr>
        <td colspan="2" class="pdf-text td10 text-bold">BANK DETAIL</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold"></td>
      </tr>
      <tr>
        <td class="td10 right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">Nama Bank</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.nama_bank }}
        </td>
      </tr>
      <tr>
        <td class="td10 right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">
          Kantor Cabang
        </td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.bank_cabang }}
        </td>
      </tr>
      <tr>
        <td class="td10 right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">
          Nama Pemilik Rekening
        </td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.pemilik_rekening }}
        </td>
      </tr>
      <tr>
        <td class="td10 right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">
          Nomor Rekening Bank
        </td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.no_rek }}
        </td>
      </tr>
      <tr>
        <td class="td10 right-no-border"></td>
        <td class="pdf-text td30 text-bold left-no-border">Mata Uang</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          {{ $route.query.mata_uang }}
        </td>
      </tr>
      <tr>
        <td colspan="2" class="pdf-text td10 text-bold">NOMOR NPWP</td>
        <td class="pdf-text td2 text-center text-bold">:</td>
        <td colspan="2" class="pdf-text td27 text-bold">
          <the-mask
            class="vendor-input text-bold"
            :mask="['##.###.###.#-###.###']"
            :value="$route.query.npwp"
            style="border:none;"
          />
        </td>
      </tr>
      <tr>
        <td colspan="5" class="no-border">
          Dengan ini menyatakan hal-hal sebagai berikut:
        </td>
      </tr>
      <tr>
        <td colspan="5" class="no-border">&shy;</td>
      </tr>
      <tr>
        <td class="no-border pdf-text text-top-center text-bold">1.</td>
        <td colspan="3" class="no-border pdf-text text-bold">
          Apakah nama yang tertera di dalam dokumen legal memiliki hubungan
          keluarga dengan pemilik atau pejabat yang berwenang di Sinarmas Group:
        </td>
        <td class="td30 no-border"></td>
      </tr>
      <tr>
        <td colspan="4" class="no-border"></td>
        <td class="text-bold no-border pdf-text">
          Ya / Tidak (pilih salah satu)
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="no-border pdf-text">
          Apabila Ya, apa/jelaskan hubungan dengan Sinarmas Group:
        </td>
        <td class="pdf-text">
          {{ $route.query.afiliasi }}
        </td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="no-border pdf-text">
          Apa Nama Group Keluarga di Sinarmas Mining Group?
        </td>
        <td class="pdf-text">{{ $route.query.relasi_group }}</td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="no-border pdf-text pl20">
          Nama
        </td>
        <td class="pdf-text">{{ $route.query.relasi_nama }}</td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="no-border pdf-text pl20">
          Jabatan
        </td>
        <td class="pdf-text">{{ $route.query.relasi_jabatan }}</td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="3" class="no-border pdf-text pl20">
          Departemen
        </td>
        <td class="pdf-text">{{ $route.query.relasi_departemen }}</td>
      </tr>
      <tr>
        <td colspan="5" class="no-border">&shy;</td>
      </tr>
      <tr>
        <td class="no-border pdf-text text-top-center text-bold">2.</td>
        <td colspan="3" class="no-border pdf-text text-bold">
          Dengan ini menyerahkan kelengkapan dokumen sebagai berikut:
        </td>
        <td class="td30 no-border"></td>
      </tr>
      <tr>
        <td class="pdf-text text-center text-bold">NO</td>
        <td class="pdf-text text-center text-bold">KELENGKAPAN DOKUMEN</td>
        <td class="pdf-text text-center text-bold"></td>
        <td class="pdf-text text-center text-bold" colspan="2">
          KETERSEDIAAN DOKUMEN
        </td>
      </tr>
      <tr>
        <td class="pdf-text text-center">1</td>
        <td class="pdf-text">KTP (Kartu Tanda Penduduk).</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text" colspan="2">{{ $route.query.doc_ktp }}</td>
      </tr>
      <tr>
        <td class="pdf-text text-center">2</td>
        <td class="pdf-text">NPWP (Nomor Pokok Wajib Pajak).</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text" colspan="2">{{ $route.query.doc_npwp }}</td>
      </tr>
      <tr>
        <td class="pdf-text text-center">3</td>
        <td class="pdf-text">KK (Kartu Keluarga).</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text" colspan="2">{{ $route.query.doc_kk }}</td>
      </tr>
      <tr>
        <td class="pdf-text text-center">4</td>
        <td class="pdf-text">Cover Depan Rekening Tabungan.</td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text" colspan="2">{{ $route.query.doc_cover }}</td>
      </tr>
      <tr>
        <td class="pdf-text text-center">5</td>
        <td class="pdf-text">
          <div>
            Surat Rekomendasi dari Pemerintah Daerah setempat.
          </div>
          <div>
            * Khusus untuk Projek CSR
          </div>
        </td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text" colspan="2">
          {{ $route.query.doc_rekomendasi }}
        </td>
      </tr>
      <tr>
        <td class="pdf-text text-center">6</td>
        <td class="pdf-text">
          <div>
            Rekening Koran 3 bulan terakhir.
          </div>
          <div>
            * Jika diperlukan
          </div>
        </td>
        <td class="pdf-text text-center">:</td>
        <td class="pdf-text" colspan="2">
          {{ $route.query.doc_rekening }}
        </td>
      </tr>
    </table>

    <div class="html2pdf__page-break" />
    <table class="pdf-table mt20">
      <tr>
        <td class="td25">
          <div class="pdf-logo-center">
            <div>
              <img src="../../../assets/img/pdf/gems.jpg" width="100%" />
            </div>
          </div>
        </td>
        <td class="td50">
          <div
            class="text-center text-bold"
            style="width:100%; border-bottom: 1px solid grey; font-size:22px"
          >
            GOLDEN ENERGY MINES (GEMS)
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            FORMULIR INFORMASI VENDOR DAN KELENGKAPAN LEGALITAS
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 13px"
          >
            BERBENTUK PERORANGAN
          </div>
          <div
            class="text-center text-bold"
            style="width:100%; font-size: 11px; font-style: italic"
          >
            INDIVIDUAL VENDOR INFORMATION AND LEGALITY REQUIREMENT
          </div>
        </td>
        <td class="td25">
          <div class="pdf-small-text text-center">F-SPM-01.01</div>
          <div class="pdf-small-text text-center">
            {{ formatFullDate(Date.now()) }}
          </div>
          <div class="pdf-small-text text-center">Page 2 of 2</div>
        </td>
      </tr>
    </table>

    <table class="pdf-table">
      <tr>
        <td class="td10 no-border">&shy;</td>
        <td class="pdf-text td30 text-bold no-border">&shy;</td>
        <td class="pdf-text td2 text-center text-bold no-border">&shy;</td>
        <td class="pdf-text td27 text-bold no-border">&shy;</td>
        <td class="pdf-text td30 text-bold no-border">&shy;</td>
      </tr>
      <tr>
        <td class="no-border"></td>
        <td colspan="4" class="pdf-text text-justify no-border pr20">
          Sehubungan dengan apa yang telah saya nyatakan dan serahkan
          sebagaimana tesebut di atas, dengan ini saya menyatakan bahwa seluruh
          salinan/fotokopi dokumen yang saya berikan adalah benar, sesuai dengan
          aslinya dan masih berlaku pada saat ditandatanganinya Pernyataan ini.
          Apabila salah satu/seluruh dokumen yang saya serahkan dan/atau apa
          yang saya nyatakan dalam Pernyataan ini adalah tidak benar maka saya
          bersedia untuk bertanggung jawab secara hukum atas Pernyataan ini.
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td colspan="4" class="no-border"></td>
        <td class="pdf-text no-border">
          ____________ , {{ formatFullDate(Date.now()) }}
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
      <tr>
        <td colspan="4" class="no-border"></td>
        <td class="pdf-small-text no-border">Meterai</td>
      </tr>
      <tr>
        <td colspan="4" class="no-border"></td>
        <td class="pdf-small-text no-border">Rp.10.000,-</td>
      </tr>
      <tr>
        <td colspan="4" class="no-border"></td>
        <td class="pdf-small-text no-border">
          ___________________________
        </td>
      </tr>
      <tr>
        <td colspan="4" class="no-border"></td>
        <td class="pdf-text no-border">Nama : {{ $route.query.nama }}</td>
      </tr>
      <tr>
        <td colspan="4" class="no-border"></td>
        <td class="pdf-text no-border">
          <div style="width:80%;border-bottom: 2px solid black">
            Jabatan : Pemilik
          </div>
        </td>
      </tr>
      <tr>
        <td class="no-border">&shy;</td>
      </tr>
    </table>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
    }
  },
  methods: {
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      html2pdf(this.$refs.document, {
        margin: 0.2,
        filename: 'Formulir Vendor Perorangan GEMS.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
